import type { LifetimeStats, SaveData } from "../core/SaveManager";

/** Achievements in four tiers; each tier pays keys. ⚠ ours */
export interface AchievementDefinition {
  id: string;
  name: string;
  stat: keyof LifetimeStats | "highScore" | "multiplier";
  tiers: [number, number, number, number];
  keys: [number, number, number, number];
}

export const achievements: AchievementDefinition[] = [
  { id: "distance", name: "Road Warrior", stat: "distance", tiers: [5000, 25000, 100000, 500000], keys: [1, 2, 3, 5] },
  { id: "coins", name: "SOL Collector", stat: "coins", tiers: [1000, 10000, 50000, 250000], keys: [1, 2, 3, 5] },
  { id: "rides", name: "Roof Rider", stat: "rides", tiers: [10, 100, 500, 2000], keys: [1, 2, 3, 5] },
  { id: "escapes", name: "Slippery", stat: "escapes", tiers: [5, 25, 100, 400], keys: [1, 2, 3, 5] },
  { id: "boards", name: "Board Breaker", stat: "boardsUsed", tiers: [5, 25, 100, 400], keys: [1, 2, 3, 5] },
  { id: "keys", name: "Key Master", stat: "keys", tiers: [5, 25, 100, 300], keys: [1, 2, 3, 5] },
  { id: "missions", name: "Mission Control", stat: "missionsDone", tiers: [3, 15, 45, 90], keys: [1, 2, 3, 5] },
  { id: "jumps", name: "Hopper", stat: "jumps", tiers: [100, 1000, 5000, 20000], keys: [1, 2, 3, 5] },
  { id: "dodges", name: "Barrier Dancer", stat: "dodges", tiers: [50, 500, 2500, 10000], keys: [1, 2, 3, 5] },
  { id: "runs", name: "Regular", stat: "runs", tiers: [10, 50, 200, 1000], keys: [1, 2, 3, 5] },
  { id: "boxes", name: "Unboxer", stat: "boxesOpened", tiers: [1, 10, 50, 200], keys: [1, 2, 3, 5] },
  { id: "score", name: "High Roller", stat: "highScore", tiers: [10000, 50000, 250000, 1000000], keys: [1, 2, 3, 5] },
  { id: "multiplier", name: "Multiplied", stat: "multiplier", tiers: [5, 10, 20, 30], keys: [1, 2, 3, 5] }
];

export function statValue(save: SaveData, stat: AchievementDefinition["stat"]): number {
  if (stat === "highScore") return save.highScore;
  if (stat === "multiplier") return save.multiplier;
  return save.stats[stat];
}

export interface Unlock {
  def: AchievementDefinition;
  tier: number;
  keys: number;
}

/** Grants every newly reached tier (keys go straight to the save). */
export function checkAchievements(save: SaveData): Unlock[] {
  const unlocks: Unlock[] = [];
  for (const def of achievements) {
    const value = statValue(save, def.stat);
    let tier = save.achievements[def.id] ?? 0;
    while (tier < 4 && value >= def.tiers[tier]) {
      unlocks.push({ def, tier: tier + 1, keys: def.keys[tier] });
      save.keys += def.keys[tier];
      tier += 1;
    }
    save.achievements[def.id] = tier;
  }
  return unlocks;
}
